/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCaretLeftRight = createReactComponent("outline", "caret-left-right", "IconCaretLeftRight", [["path", { "d": "M14 18l6 -6l-6 -6v12", "key": "svg-0" }], ["path", { "d": "M10 18l-6 -6l6 -6v12", "key": "svg-1" }]]);

export { IconCaretLeftRight as default };
//# sourceMappingURL=IconCaretLeftRight.mjs.map
